<app-card-kpi-details />
